<template>
    <div class="timesheet-2">
        <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)" :icon="icon"></myBreadCrumb> -->
        <create-dialog v-model="dialog" :item="item" @fetch="fetchData"></create-dialog>
        <v-row no-gutters>
            <!-- SUM INFO -->
            <!-- <v-card class="col mb-3">
                <v-card-title>Tổng hợp giờ công nhân viên</v-card-title>
                <v-card-text>
                    <v-card-subtitle>Từ ngày: {{startMonth}}</v-card-subtitle>
                    <v-card-subtitle>Đến ngày: {{ endMonth}} </v-card-subtitle>
                </v-card-text>
            </v-card>
            <v-card class="col-12 col-md-2 mx-0 mx-md-3 mb-3">
                <v-list dense>
                    <v-list-item>
                        <v-list-item-icon style="width: 15rem">
                            <v-icon color="blue" left> mdi-sigma </v-icon>
                            <v-subheader>
                                Tổng tăng ca thường
                            </v-subheader>
                        </v-list-item-icon>

                        <v-list-item-content class="text-">
                            <v-list-item-title>{{sumObj?sumObj.sumNormal:""}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    
                    <v-list-item>
                        <v-list-item-icon style="width: 15rem">
                            <v-icon color="indigo" left>
                                mdi-calendar-account
                            </v-icon>
                            <v-subheader>
                            Tổng tăng ca ngày nghỉ
                            </v-subheader>
                        </v-list-item-icon>

                        <v-list-item-content class="text-">
                            <v-list-item-title>{{sumObj?sumObj.sumDayOff:""}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-icon style="width: 15rem">
                            <v-icon color="pink" left>
                                mdi-ferry
                            </v-icon>
                            <v-subheader>
                            Tổng tăng ca lễ
                            </v-subheader>
                        </v-list-item-icon>

                        <v-list-item-content class="text-">
                            <v-list-item-title>{{sumObj?sumObj.sumHoliday:""}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card> -->
            
            <!-- <v-card class="col-12 col-md-2 mb-3">
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <chart ref="chartOvertime" label="Tỉ lệ tăng ca"
                            :chartData="chartDataOvertime" maxWidth="300px"
                            chartType="pie" >
                            </chart>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card> -->
            <v-card class="rounded-xl elevation-3 pb-4" width="100%">
                 <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
                    TỔNG HỢP GIỜ CÔNG
                    <v-spacer></v-spacer>
                    <div style="width: 200px">
                        <month-picker v-model="month" label="Chọn tháng" width="100%" outlined dense hide-details style="background-color: white;"></month-picker>
                    </div>
                </v-card-title>
                
                <div class="px-6 py-2">
                    <v-stepper non-linear class="elevation-0 grey lighten-4 rounded-xl border-1" flat v-model="step">
                        <v-stepper-header>
                            <v-stepper-step editable color="teal darken-4" :step="1"> <span class="font-weight-medium">1. Khóa dữ liệu</span> </v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step editable color="teal darken-4" :step="2"> <span class="font-weight-medium">2. Khóa TT nhân viên</span> </v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step editable color="teal darken-4" :step="3"> <span class="font-weight-medium">3. Tính công</span> </v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step editable color="teal darken-4" :step="4"> <span class="font-weight-medium">4. Chốt công</span> </v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step editable color="teal darken-4" :step="5"> <span class="font-weight-medium">5. Xuất excel</span> </v-stepper-step>
                        </v-stepper-header>
                    </v-stepper>
                </div>
                <v-tabs-items v-model="step">
                    <v-tab-item :value="1">
                        <v-row class="ma-0">
                            <!-- Khóa giờ công theo phòng ban -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-card flat class="border rounded-xl">
                                    <v-card-title class="text-subtitle-1 font-weight-bold grey--text text--darken-3">
                                        Khóa phiếu & giờ công
                                    </v-card-title>
                                    <v-card-text>
                                        <v-data-table
                                            :headers="departmentHeaders"
                                            :items="departments" dense
                                            :items-per-page="-1"
                                            hide-default-footer
                                            show-select height="calc(100vh - 400px)" fixed-header
                                            item-key="code"
                                            v-model="selected" @input="lockDepartments = selected.map(x=>x.code)" 
                                        >
                                            
                                        </v-data-table>
                                    </v-card-text>
                                    <v-card-actions class="justify-center pb-4">
                                        <v-btn color="green" class="rounded-lg" large style="text-transform: none;" dark type="button" @click="lockData"> Khóa phiếu & giờ công</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                            
                            <!-- Khóa giờ công theo ngày -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-card flat class="border rounded-xl" height="100%">
                                    <v-card-title class="text-subtitle-1 font-weight-bold grey--text text--darken-3">
                                        Khóa giờ công theo ngày
                                    </v-card-title>
                                    <v-card-text class="d-flex flex-column align-center">
                                        <!-- Custom Calendar Grid -->
                                        <div class="calendar-container w-100" style="max-width: 400px;">
                                            <div class="d-flex text-center font-weight-bold grey--text text--darken-2 mb-2 text-caption">
                                                <div style="width: 14.28%">T2</div>
                                                <div style="width: 14.28%">T3</div>
                                                <div style="width: 14.28%">T4</div>
                                                <div style="width: 14.28%">T5</div>
                                                <div style="width: 14.28%">T6</div>
                                                <div style="width: 14.28%">T7</div>
                                                <div style="width: 14.28%" class="red--text">CN</div>
                                            </div>
                                            <v-row no-gutters>
                                                <v-col cols="2" style="max-width: 14.28%; flex: 0 0 14.28%" v-for="(day, index) in monthDays" :key="index" class="pa-1">
                                                    <div v-if="day.empty" class="day-box empty"></div>
                                                    <v-card v-else 
                                                            outlined 
                                                            class="day-box d-flex flex-column align-center justify-center position-relative" 
                                                            :class="{'bg-grey-locked': day.isLocked, 'selected-box': selectedLockDate === day.dateStr}"
                                                            @click="selectedLockDate = day.dateStr"
                                                    >
                                                        <span class="font-weight-medium text-body-2" :class="{'grey--text text--lighten-1': day.isLocked}">{{ day.day }}</span>
                                                        <v-icon v-if="day.isLocked" x-small color="grey darken-1" class="lock-icon" :title="day.note">mdi-lock</v-icon>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                        </div>

                                        <div class="mt-4 w-100 flex-grow-1"></div>
                                    </v-card-text>
                                    <v-card-actions class="justify-center pb-4">
                                        <v-btn :color="isCurrentDateLocked ? 'red' : 'orange'" 
                                               class="rounded-lg" 
                                               large 
                                               style="text-transform: none;" 
                                               dark 
                                               type="button" 
                                               @click="handleLockUnlock" 
                                               :loading="lockDateLoading"
                                               :disabled="!selectedLockDate"
                                        > 
                                            {{ isCurrentDateLocked ? 'Mở khóa' : 'Khóa giờ công' }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item :value="2">
                        <v-card flat width="100%">
                            <v-card-text class="">
                                <v-btn color="green" class="rounded-lg mx-2" dark style="text-transform: none;" large @click.prevent="setEmployee" :loading="processDataLoading">
                                     Khóa dữ liệu
                                </v-btn>
                                <v-btn text class="rounded-lg mx-2" style="text-transform: none;" large color="red" @click="resetEmployee">
                                    <v-icon left>mdi-lock-open</v-icon> Mở khóa
                                </v-btn>

                                <v-btn text class="rounded-lg mx-2" style="text-transform: none;" large color="orange" @click="fetchEmployee">
                                    <v-icon left>mdi-refresh</v-icon> Reload
                                </v-btn>
                                <!-- <v-spacer></v-spacer> -->

                                <v-text-field dense v-model="employeeSearch" label="Tìm kiếm" style="max-width: 200px; float: right;" hide-details outlined class="d-inline-flex"></v-text-field>
                                <v-data-table :items="employees" :headers="employeeHeaders" :search="employeeSearch" dense fixed-header
                                :loading="processDataLoading" multi-sort height="calc(100vh - 400px)">
                                    
                                    <template v-slot:[`item.createdAt`]="{ item }">
                                        {{ $formatter.formatDate(item.createdAt, 'DD/MM/YYYY HH:mm:ss') }}
                                    </template>
                                    
                                    <template v-slot:[`item.hireDate`]="{ item }">
                                        {{ $formatter.formatDate(item.hireDate, 'DD/MM/YYYY') }}
                                    </template>
                                    
                                    <template v-slot:[`item.status`]="{ item }">
                                        <v-chip label color="green lighten-3" class="green--text text--darken-4" v-if="item.status==1">Hoạt động</v-chip>
                                        <v-chip label color="orange lighten-3" class="orange--text text--darken-4" v-if="item.status==2">Tạm nghỉ</v-chip>
                                        <v-chip label color="cyan lighten-3" class="cyan--text text--darken-4" v-if="item.status==3">Thai sản</v-chip>
                                        <v-chip label color="red lighten-3" class="red--text text--darken-4" v-if="item.status==4">Nghỉ việc</v-chip>
                                        <!-- <v-chip label color="grey lighten-3" class="grey--text text--darken-4" v-else>{{ item.status }}</v-chip> -->
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item :value="3">
                        <v-card flat width="100%" height="400px" >
                            <v-card-text class="text-center">
                                <v-btn color="green" class="rounded-lg mx-2" dark 
                                    style="text-transform: none;" large @click.prevent="processData" :loading="processDataLoading"> Tính công</v-btn>
                                <v-btn :text="progressValue==100?false:true" class="rounded-lg mx-2" style="text-transform: none;" large @click="step=4" 
                                    :color="progressValue==100 ? 'orange': ''" :outlined="progressValue==100?true:false">Xem dữ liệu</v-btn>

                                <v-progress-linear class="mt-2"
                                v-model="progressValue"
                                height="14"
                                color="green"
                                >
                                    <template v-slot:default="{ value }">
                                        <strong class="white--text">{{ Math.ceil(value) }}%</strong>
                                    </template>
                                </v-progress-linear>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item :value="4">
                        <v-tabs color="green">
                            <v-tab>Báo cáo công</v-tab>
                            <v-tab>Báo cáo tăng ca</v-tab>
                            <v-divider vertical class="mx-4"></v-divider>
                            <v-btn color="orange" outlined class="mr-4 ml-0 my-auto rounded-lg" style="text-transform: none;" @click="step=5" large>Xem excel</v-btn>
                            <v-btn class="my-auto ml-auto mr-4 my-auto" color="orange" icon  @click="fetchData"><v-icon>mdi-refresh</v-icon></v-btn>

                            <v-tab-item>
                                <v-data-table
                                :mobile-breakpoint="0"
                                height="calc(100vh - 370px)" fixed-header
                                :headers="workTimeHeaders"
                                :items="dItems"
                                :page.sync="tableParams.page"
                                :sort-by.sync="tableParams.sortBy"
                                :sort-desc.sync="tableParams.sortDesc"
                                :server-items-length="rowCount"
                                :loading="isLoading"
                                loading-text="Đang tải dữ liệu..."
                                >
                                    <template v-slot:[`body.prepend`]="" >
                                        <tr class="filter">
                                            <td></td>
                                            <td>
                                                <v-text-field placeholder="Nhập" dense v-model="filters.employeeCode" hide-details outlined></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field placeholder="Nhập" dense v-model="filters.employeeName" hide-details outlined></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field placeholder="Nhập" dense v-model="filters.departmentName" hide-details outlined></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field placeholder="Nhập" dense v-model="filters.departmentType" hide-details outlined></v-text-field>
                                            </td>
                                            <td colspan="100%"></td>
                                        </tr>
                                    </template>

                                    <template v-slot:[`item.actions`]="{item}" >
                                        <v-btn x-small depressed rounded class="mx-1 blue--text text--darken-3 font-weight-bold" color="blue lighten-4" @click="edit(item)">
                                            <v-icon left small>mdi-eye</v-icon> Chi tiết
                                        </v-btn>
                                    </template>
                                    
                                    <template v-slot:[`item.employeeInfo`]="{item}">
                                        <div class="subtitle-2 font-weight-bold" style="line-height: 1.2;">{{item.name}}</div>
                                        <div class="caption grey--text">{{item.code}}</div>
                                    </template>

                                    <template v-slot:[`item.department`]="{ item }">
                                        <v-chip class="caption font-weight-bold" color="teal lighten-5" text-color="teal darken-4" small>
                                            {{item.department}}
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item.isConfirmed`]="{ item }">
                                        <v-chip :color="$helper.formatStatus(item.isConfirmed).color" label small outlined>
                                            <strong> {{$helper.formatStatus(item.isConfirmed).text}}</strong>
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item.isLock`] = "{item}">
                                        <v-icon v-if="item.isLock" color="grey">mdi-lock</v-icon>
                                        <v-icon v-else color="green">mdi-lock-open</v-icon>
                                    </template>

                                    <!-- BAO CAO CONG -->
                                    <template v-for="workTimeHeader in workTimeHeaders.slice(4, -(symbols.length + appendHeaders.length))" v-slot:[`item.${workTimeHeader.value}`]="{ item }">
                                        <div :key="workTimeHeader.value">
                                            <div v-if="workTimeHeader.isSunday && item.isOffice" >
                                                <span class="orange--text">CN</span>
                                            </div>
                                            <div v-else :key="workTimeHeader.value">
                                                <div v-if="item[workTimeHeader.value]"  class="ma-auto" style="cursor:pointer">
                                                    <span v-if="item[workTimeHeader.value].symbol!='x'">{{`${item[workTimeHeader.value].symbol}-`}}</span>{{item[workTimeHeader.value].validActualTime}}
                                                    <!-- <span v-if="item[workTimeHeader.value].symbol!='x'">{{`${item[workTimeHeader.value].symbol} (${Math.min(round2Dec(item[workTimeHeader.value].leaveTime + item[workTimeHeader.value].actualWorkTime), item[workTimeHeader.value].shiftHour )})`}}</span>
                                                    <span v-else> {{round2Dec(item[workTimeHeader.value].actualWorkTime + item[workTimeHeader.value].holidayActualTime + item[workTimeHeader.value].leaveTime)}} </span> -->
                                                </div>
                                                <div v-else>
                                                    <span>KL</span>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </v-data-table>
                            </v-tab-item>

                            <v-tab-item>
                                <v-data-table
                                :mobile-breakpoint="0"
                                height="500px" fixed-header
                                :headers="overtimeHeaders"
                                :items="dItems"
                                :page.sync="tableParams.page"
                                :sort-by.sync="tableParams.sortBy"
                                :sort-desc.sync="tableParams.sortDesc"
                                :server-items-length="rowCount"
                                :loading="isLoading"
                                loading-text="Đang tải dữ liệu...">
                                    <!-- BAO CAO TANG CA -->
                                    <template v-slot:[`item.actions`]="{item}" >
                                        <v-btn x-small depressed rounded class="mx-1 blue--text text--darken-3 font-weight-bold" color="blue lighten-4" @click="edit(item)">
                                            <v-icon left small>mdi-eye</v-icon> Chi tiết
                                        </v-btn>
                                    </template>
                                    
                                    <template v-slot:[`item.employeeInfo`]="{item}">
                                        <div class="subtitle-2 font-weight-bold" style="line-height: 1.2;">{{item.name}}</div>
                                        <div class="caption grey--text">{{item.code}}</div>
                                    </template>

                                    <template v-slot:[`item.department`]="{ item }">
                                        <v-chip class="caption font-weight-bold" color="teal lighten-5" text-color="teal darken-4" small>
                                            {{item.department}}
                                        </v-chip>
                                    </template>

                                    <template v-for="overtimeHeader in overtimeHeaders.slice(4, -(appendHeadersOvertime.length))" v-slot:[`item.${overtimeHeader.value}`]="{ item }">
                                        <div :key="overtimeHeader.value" >
                                            <div v-if="item[overtimeHeader.value]"  class="ma-auto" style="cursor:pointer">
                                                <!-- <span v-if="item[overtimeHeader.value].isDayOff"> {{round2Dec(item[overtimeHeader.value].overtime + item[overtimeHeader.value].actualWorkTime)}} </span>
                                                <span v-if="item[overtimeHeader.value].leaveTime>0"> {{round2Dec(item[overtimeHeader.value].overtime + item[overtimeHeader.value].actualWorkTime 
                                                                                                                - (item[overtimeHeader.value].shiftHour - item[overtimeHeader.value].leaveTime))}} </span> -->
                                                <span> {{round2Dec(item[overtimeHeader.value].overtime)}} </span>
                                            </div>
                                            <div v-else>
                                                0
                                            </div>
                                        </div>
                                    </template>
                                </v-data-table>
                            </v-tab-item>
                        </v-tabs>
                    </v-tab-item>
                    <v-tab-item :value="5">
                        <v-card flat min-height="400px">
                            <v-tabs>
                                <v-tab> Excel mặc định
                                </v-tab>
                                <v-tab> Excel theo phòng ban
                                </v-tab>
                                <v-tab-item>
                                    <v-card-title >
                                        <v-btn color="green" class="rounded-lg mx-4" large dark @click="exportExcel2(true)" style="text-transform: none;" :loading="excelLoading">Xuất excel</v-btn>
                                        <v-btn text @click="downloadFile(excelUrl)" type="button" :disabled="excelUrl ? false : true">Tải về</v-btn>
                                    </v-card-title>
                                    <v-card-text class="text-center">
                                        <iframe class="mx-auto" v-if="excelUrl"
                                        :src="`https://view.officeapps.live.com/op/embed.aspx?src=${excelUrl}`"
                                        width="100%"
                                        height="600px"
                                        frameborder="0">
                                        </iframe>
                                        <strong v-else>Chưa có bản preview, hãy ấn xuất EXCEL</strong>
                                    </v-card-text>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card-title >
                                        <v-btn color="green" class="rounded-lg mx-4" large dark @click="exportExcelReport(true)" style="text-transform: none;" :loading="excelLoading">Xuất excel</v-btn>
                                        <v-btn text @click="downloadFile(excelDeptUrl, 'gio-cong-theo-phong-ban')" type="button" :disabled="excelDeptUrl ? false : true">Tải về</v-btn>
                                    </v-card-title>
                                    <v-card-text class="text-center">
                                        <iframe class="mx-auto" v-if="excelDeptUrl"
                                        :src="`https://view.officeapps.live.com/op/embed.aspx?src=${excelDeptUrl}`"
                                        width="100%"
                                        height="600px"
                                        frameborder="0">
                                        </iframe>
                                        <strong v-else>Chưa có bản preview, hãy ấn xuất EXCEL</strong>
                                    </v-card-text>
                                </v-tab-item>
                            </v-tabs>
                            <!-- <v-card-actions>
                            </v-card-actions> -->
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>

            </v-card>

        </v-row>
        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title>Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
                <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
                <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <!-- KHÓA CÔNG -->
        <v-dialog v-model="lockWorkTime" width="500" scrollable>
            <v-card  :loading="lockDataLoading">
                <v-card-title>Khóa Công
                    <v-spacer></v-spacer>
                    <v-icon dark @click="lockWorkTime=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-form @submit.prevent="lockData" id="lockForm">
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete multiple item-text="name" item-value="code" :items="departments" v-model="lockDepartments" small-chips clearable deletable-chips
                                label="Chi Nhánh/Phòng Ban" hide-no-data @change="fetchDepartment" :rules='[v=>!!v||"Chọn dữ liệu"]' outlined>
                                    <template v-slot:[`prepend-item`]="" >
                                        <v-list-item>
                                            <v-list-item-action>
                                                <v-checkbox :value="lockDepartments==departments" @change="selectAll"></v-checkbox>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                Chọn tất cả
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="primary" type="submit" form="lockForm">Khóa Công</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- //INIT -->
        <v-dialog v-model="initDialog" width="500">
            <v-card :loading="initLoading">
                <v-card-title class="secondary white--text">Tính Công
                    <v-spacer></v-spacer>
                    <v-icon dark @click="initDialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-form @submit.prevent="initData">
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <month-picker v-model="monthForm" label="Chọn tháng chốt công" width="500px"></month-picker>
                                <!-- <v-checkbox v-model="form.isAll" readonly label="Áp dụng cho tất cả phòng ban"></v-checkbox> -->
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn small color="primary" type="submit">Tính Công</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <!-- CHỐT GIỜ CÔNG -->
        
        <excel-export v-model="excelDialog" :month="filters.month" :year="filters.year"></excel-export>
    </div>
</template>

<script>
import http from '@/components/services/http-common';
import ApiServices from '@/components/services/ApiServices';
import myBreadCrumb from '@/components/BreadCrumb';
import DataFilter from '@/components/DataFilter';
import CreateDialog from './Create.vue';
import Excel from './Excel.vue'
// import CreateDialog from './Create.vue';
import * as moment from "moment/moment";
import Chart from '@/components/Charts/Chart.vue';
import StoreDialog from './Store.vue';
import {mtData} from './data'
import EmployeeApi from './employeeApi'

export default {
    components: {
        myBreadCrumb,
        'data-filter': DataFilter,
        'create-dialog': CreateDialog,
        'store-dialog': StoreDialog,
        'excel-export': Excel,
        "chart": Chart,
        'time-selector': Excel,
    },
    props: ["breadcrumbs", "icon","department"],
    watch: {
        department(val) {
            console.log("has department");
        },
        lockWorkTime () {
            this.fetchLockData()
        },
        value: {
            handler(val){
                if(val)
                {
                    if(this.department){
                        // this.fetchDepartment(this.department);
                        this.form.departmentCode = this.department;
                    }
                }
            },
            "form.departmentCode": function(val){
                this.fetchPosition(this.form.departmentCode);
            },
        },
        departmentSearch:{
            handler(val){
                this.fetchDepartment(val);
            }
        },
        dialog(val) {
            if(!this.dialog)
                this.item=null;
        },
        tableParams: {
            handler (val) {
                this.fetchData();
            },
            deep: true,
        },
        filters: {
            handler: _.debounce(function(){
                    this.tableParams.page=1;
                    this.fetchData();
                    this.fetchEmployee()
                }, 500),
            deep: true,
        },
        
        month:{
            handler(val){
                this.filters.month=moment(val, "YYYY-MM").format("MM");
                this.filters.year=moment(val, "YYYY-MM").format("YYYY");
                this.fetchLockData();
                this.fetchLockedDatesByDay();
                this.selectedLockDate = null;
                this.progressValue = 0;
                this.processDataLoading = false;
                this.excelDeptUrl = "";
                this.excelUrl = "";
            }
        },
        monthForm:{
            handler(val){
                this.form.processMonth=moment(val, "YYYY-MM").format("MM");
                this.form.processYear=moment(val, "YYYY-MM").format("YYYY");
            }
        },
    },
    computed: {
        isCurrentDateLocked() {
            return this.lockedDatesArray.includes(this.selectedLockDate);
        },
        monthDays() {
            let days = [];
            if (!this.month) return [];
            let start = moment(this.month, "YYYY-MM").startOf('month');
            let end = moment(this.month, "YYYY-MM").endOf('month');
            
            let startDayOfWeek = start.isoWeekday();
            
            for(let i=1; i < startDayOfWeek; i++) {
                days.push({ empty: true });
            }
            for(let i=1; i <= end.date(); i++) {
                let dateStr = moment(this.month, "YYYY-MM").date(i).format("YYYY-MM-DD");
                let lockData = (this.lockedDatesData || []).find(x => moment(x.date).format("YYYY-MM-DD") === dateStr);
                
                days.push({
                    empty: false,
                    day: i,
                    dateStr: dateStr,
                    isLocked: !!lockData,
                    note: lockData ? lockData.note : ''
                });
            }
            return days;
        },
        startMonth: function() {
            return moment(this.month, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
        },
        endMonth: function() {
            return moment(this.month, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
        },
        params: function() {
            return {...this.tableParams, ...this.filters}
        },
        dItems: function () {
            let mapped = this.items.map(x=>{
                let obj = Object.assign({}, x);
                delete obj.timesheets;
                delete obj.symbols;
                x.timesheets?.forEach(y => {
                    obj[y.date] = y.value;
                });
                for(var i=0; i < this.symbols.length; i++){
                    obj[this.symbols[i]]=x.symbolValues==null?0: x.symbolValues[i]
                }
                return obj;
            })
            return mapped;
        },
        workTimeHeaders: function () {
            let date = moment(this.month+"-01", "YYYY-MM-DD");
            let end = moment(date.format("YYYY-MM-DD")).endOf("month");
            // date = date.add(1,"days")
            let dates = [];
            let cHeaders = [];
            while(date<=end){
                dates.push({ text: date.format("YYYY-MM-DD"), value: date.format("YYYYMMDD"), width: 50, sortable: false, isSunday: date.day()==0, class: date.isoWeekday()==7?'red-header':''})
                date = date.add(1, "days");
            }
            let symbolHeaders = [];
            this.symbols.forEach(x=>{
                symbolHeaders.push({ text: x, value: x, width: 50, sortable: false})
            })
            cHeaders = this.headers.concat(dates).concat(symbolHeaders).concat(this.appendHeaders);
            return cHeaders;   
        },
        overtimeHeaders: function () {
            let date = moment(this.month+"-01", "YYYY-MM-DD");
            let end = moment(date.format("YYYY-MM-DD")).endOf("month");
            // date = date.add(1,"days")
            let dates = [];
            let cHeaders = [];
            while(date<=end){
                // if(date.isoWeekday()==1)
                //     this.sundayCodes.push(date.format("YYYYMMDD"));
                dates.push({ text: date.format("YYYY-MM-DD"), value: date.format("YYYYMMDD"), width: 50, sortable: false, isSunday: date.day()==0, class: date.isoWeekday()==7?'red-header':''})
                date = date.add(1, "days");
            }
            let symbolHeaders = [];
            this.symbols.forEach(x=>{
                symbolHeaders.push({ text: x, value: x, width: 50, sortable: false})
            })
            cHeaders = this.headers.concat(dates).concat(this.appendHeadersOvertime);
            return cHeaders;   
        }
    },
    data () {
        return mtData
    },
    methods: {
        workTimeReport() {
            console.log("Work Time Report");
        },
        overTimeReport() {
           
        },
        round2Dec(val){
            return Math.round(val * 100) / 100
        },
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        formatStatus(value){
            switch(value){
                case 0:{
                    return "Chờ duyệt";
                }
                case 1:{
                    return "Chấp nhận";
                }
                case 2:{
                    return "Từ chối";
                }
            }
        },
        formatTime(value) {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
        },
        fetchLeavePlan(){
            ApiServices.fetchLeavePlan().then(res=>{
                this.leavePlans = res.data;
            })
        },
        fetchDepartment() {
            return http.get("departments/fetch").then(res => {
                this.departments = res.data;
            })
        },
        fetchEmployee() {
            this.processDataLoading = true
            return EmployeeApi.get(moment(this.month, 'YYYY-MM').format('YYYY-MM-01')).then(d => { this.employees = d.data}).finally(() => this.processDataLoading = false)
        },
        setEmployee() {
            this.processDataLoading = true
            return EmployeeApi.set(moment(this.month, 'YYYY-MM').format('YYYY-MM-01'))
            .then(() => this.fetchEmployee())
            .finally(() => { this.processDataLoading = false})
        },
        resetEmployee() {
            this.processDataLoading = true
            return EmployeeApi.reset(moment(this.month, 'YYYY-MM').format('YYYY-MM-01'))
            .then(() => this.fetchEmployee())
            .finally(() => { this.processDataLoading = false})
        },
        fetchData () {
            this.isLoading = true;
            return http.get(this.ROOT_URL, {
                params: this.params
            })
            .then(res => {
                this.isLoading = false;
                this.items = res.data.results;
                this.symbols = res.data.symbols;
                this.rowCount = res.data.rowCount;
                this.sumObj = res.data.sumObj;
                //chart
                this.chartDataOvertime.datasets[0].data=[];
                this.chartDataOvertime.datasets[0].backgroundColor=[];
                this.chartDataOvertime.datasets[0].borderColor=[];

                for (const property in this.sumObj) {
                    this.chartDataOvertime.datasets[0].data.push(this.sumObj[property]);
                    this.chartDataOvertime.datasets[0].backgroundColor.push(this.getRandomColor());
                    this.chartDataOvertime.datasets[0].borderColor.push('rgb(225, 225, 225)');
                }

                this.$refs.chartOvertime.update()
            })
            .catch(err => {
            }).finally(()=> {this.isLoading = false})
        },
        getRandomColor() {
            var letters = '0123456789ABCDEF'.split('');
            var color = '#';
            for (var i = 0; i < 6; i++ ) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },
        fetchLockData ()
        {
            return http.get("timeRollProcesses", {
                params: {
                    month: moment(this.month, "YYYY-MM").format("MM"),
                    year: moment(this.month, "YYYY-MM").format("YYYY"),
                }
            }).then(res => {
                this.lockDepartments = res.data.map(x=> {return x.departmentCode});
                this.selected = this.departments.filter(x=> this.lockDepartments.includes(x.code))
                console.log(this.selected)
               
            })
        },
        fetchLockedDatesByDay() {
            return http.get(`lockTimesheets?month=${this.month}`).then(res => {
                console.log(res.data.data, "***********")
                if(res.data.data) {
                    this.lockedDatesData = res.data.data;
                    this.lockedDatesArray = res.data.data.map(item => moment(item.date).format("YYYY-MM-DD"));
                }
            }).catch(err => console.log(err));
        },
        lockDataByDate() {
            if (!this.selectedLockDate) return;
            this.lockDateLoading = true;
            return http.post(`lockTimesheets/exec?inputDate=${this.selectedLockDate}`, {
                note: this.lockDateNote
            }).then(res => {
                this.fetchLockedDatesByDay();
                alert("Khóa giờ công thành công");
            }).catch(err => {
                alert("Có lỗi xảy ra");
                console.log(err);
            }).finally(() => {
                this.lockDateLoading = false;
            });
        },
        handleLockUnlock() {
            if (!this.selectedLockDate) return;
            
            this.lockDateLoading = true;
            return http.post(`lockTimesheets/exec?inputDate=${this.selectedLockDate}`).then(res => {
                this.fetchLockedDatesByDay();
                alert("Cập nhật trạng thái khóa thành công");
            }).catch(err => {
                alert("Có lỗi xảy ra");
                console.log(err);
            }).finally(() => {
                this.lockDateLoading = false;
            });
        },
        lockData () {
            return http.post("TimeRollProcesses/lock", {
                lockDepartments: this.lockDepartments,
                month: moment(this.month, "YYYY-MM").format("MM"),
                year: moment(this.month, "YYYY-MM").format("YYYY"),
            }).then(res=> {
                this.lockWorkTime = false;
            })
        },
        selectAll(value)
        {
            this.lockDepartments = value ? this.departments.map(x=>{return x.code}): [];
        },
        processData ()
        {   
            // this.isLoading = true;
            this.processDataLoading = true;
            return http.get("monthlyTimesheets/process", {
                params: {
                    month: moment(this.month, "YYYY-MM").format("MM"),
                    year: moment(this.month, "YYYY-MM").format("YYYY"),
                }
            }).then(res=>{
                // this.interval = setInterval(this.checkBackground, 1000);
                
                this.progressValue = 50
                this.store().then(() => {
                    this.progressValue = 100
                    this.processDataLoading =false;
                })
            }).catch(e => {
                this.processDataLoading = false;
                alert("Có lỗi xảy ra")
            });
        },
        store()
        {
            let month = moment(this.month, "YYYY-MM");
            this.storeLoading = false;
            return http.get("monthlyTimesheets/store", {
                params: {
                    month: month.format("MM"),
                    year: month.format("YYYY"),
                }
            }).then(res=>{
            }).finally(()=> {this.storeLoading = true});
        },

        // calData(item) {
        //     this.reloadLoading = true;
        //     return http.get("monthlyTimesheets/calculate", {
        //         params:{
        //             employeeCode: item.code,
        //             year: this.form.processYear,
        //             month: this.form.processMonth
        //         }
        //     }).then(res=>{
        //         this.reloadLoading = false;
        //     })
        // },
        reloadData(item){
            this.reloadDialog = true;
            return http.get("monthlyTimesheets/reload", {
                params:{
                    year: this.form.processYear,
                    month: this.form.processMonth
                }
            }).then(res=>{
            }).finally(()=>{
                this.reloadLoading = false;
            })
        },

        saveAll() {
            return http.post("monthlyTimesheets/save-all", this.form).then(res=>{
                this.saveDialog = false;
            })
        },
        unSaveAll() {
            return http.post("monthlyTimesheets/unsave-all", this.form).then(res=>{
                this.unSaveDialog = false;
            })
        },

        edit(item){
            this.item = item;
            this.dialog = true;
        },
        
        remove(item){
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            return http.delete(this.ROOT_URL+this.targetItem.code).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            })
        },

        //export
         
        exportExcel2 (sendLink = false) {
            const mode = "URL"
            let month = moment(this.month, "YYYY-MM");
            // this.form.year = this.year;
            // this.form.month = this.month;
            this.excelLoading = true;
            return http.get("monthlyTimesheets" + "/export2" + `?sendLink=${sendLink}`, {
                params: {
                    month: month.format("MM"),
                    year: month.format("YYYY")
                },
                responseType: mode == 'STREAM' ? 'blob' : 'json',
            }).then(res =>{
                if(mode == "STREAM") {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `GIO_CONG_THANG_${this.form.month}_${this.form.year}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                }else {
                    this.excelUrl = res.data.data
                    console.log(this.excelUrl)
                }
            }).catch (err => {
                throw err;
            }).finally(()=> this.excelLoading=false);
        },

        
        exportExcelReport(sendLink = false) {
            const mode = "URL"
            this.loading = true;
            this.excelLoading = true
            let month = moment(this.month, "YYYY-MM");
            return http.get("monthlytimesheets/export-rotation", {
                params: {
                    month: month.format("MM"),
                    year: month.format("YYYY")
                }
            }).then(res => {
                
                this.excelDeptUrl = res.data
                this.excelLoading = false
                console.log(this.excelDeptUrl, sendLink)
                
                if(mode == "STREAM") {
                    return http.get(res.data, {
                        responseType: mode == 'STREAM' ? 'blob' : 'json',
                    }).then(res2 => {
                        let blob = new Blob([res2.data]), url = window.URL.createObjectURL(blob)
                        
                        let filename = res.data.split("/").pop();
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
                        this.loading = false;
                    })
                }
            })
        },
        
        async downloadFile(inputUrl, filename = "gio-cong") {
            var url = "https://tshrm.api.trungsonpharma.com/DANH_SACH_NHAN_VIEN-SINH-NHAT-20241213201147703.xlsx";
            url = inputUrl

            const res = await fetch(url);
            const blob = await res.blob();
            const blobUrl = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = filename + ".xlsx";
            a.click();

            URL.revokeObjectURL(blobUrl);
        },

        // deprecated
        checkBackground(){
            //disabled
            return
            return http("monthlyTimesheets/background-status").then(res => {
                if(res.data==true)
                {
                    this.processDataLoading =true;
                    // this.isLoading = true;
                } else {
                    console.log("clear intervla", this.interval)
                    this.processDataLoading =false;
                    this.progressValue = 50
                    this.store().then(() => {
                        this.progressValue = 100
                    })
                    clearInterval(this.interval);
                }
            }).catch(err => {
                clearInterval(this.interval);
            })
        }
    },
    created () {
        this.fetchData();
        EmployeeApi.get(moment(this.month, "YYYY-MM").format("YYYY-MM-01"))
        
        this.fetchDepartment();
        this.fetchLockData()
        this.fetchLockedDatesByDay();
        this.interval = setInterval(this.checkBackground, 5000);
    },
    beforeDestroy(){
        clearInterval(this.interval);
    },
    destroyed()
    {
        this.interval = clearInterval();
    }
}
</script>

<style scoped>
    @media screen and (min-width: 600px) {
        
        ::v-deep table > thead > tr > th:nth-child(1),
        ::v-deep table > tbody > tr > td:nth-child(1) {
            position: sticky !important; 
            position: -webkit-sticky !important; 
            left: 0;
            /* margin-left: -100px !important; */
            z-index: 3;
            background: white;
        }

        ::v-deep table > thead > tr > th:nth-child(2),
        ::v-deep table > tbody > tr > td:nth-child(2){
            position: sticky !important; 
            position: -webkit-sticky !important; 
            left: 110px !important; 
            z-index: 3;
            background: white;
        }
        ::v-deep table > thead > tr > th:nth-child(3),
        ::v-deep table > tbody > tr > td:nth-child(3){
            position: sticky !important;
            position: -webkit-sticky !important;
            left: 210px !important;
            z-index: 3;
            background: white;
        }
        
    }
    ::v-deep .v-data-table tbody
    tr:hover:not(.v-data-table__expanded__content) {
        background: white !important;
    }
    
    ::v-deep table > thead > tr > th:nth-child(1) {
        z-index: 4;
    }
    ::v-deep table > thead > tr > th:nth-child(2) {
        z-index: 4;
    }
    ::v-deep table > thead > tr > th:nth-child(3) {
        z-index: 4;
    }
    ::v-deep .red-header{
        color: red !important;
    }
</style>
<style scoped>
/* Custom Calendar Styling */
.day-box {
    aspect-ratio: 1;
    cursor: pointer;
    border-radius: 6px !important;
    transition: all 0.2s;
}
.day-box:hover {
    border-color: #4caf50 !important;
}
.day-box.selected-box {
    border: 2px solid #4caf50 !important;
    background-color: #e8f5e9;
}
.bg-grey-locked {
    background-color: #e0e0e0 !important;
    border-color: #bdbdbd !important;
}
.day-box.bg-grey-locked.selected-box {
    border: 2px solid #4caf50 !important;
}
.day-box.empty {
    border: none !important;
    background: transparent !important;
    cursor: default;
}
.lock-icon {
    position: absolute;
    bottom: 2px;
    right: 2px;
}
</style>